import { Button } from '@mui/material';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import IngredientManagementDialog from '../../../ingredient_management/IngredientManagementDialog';
import { createIngredient } from '../../../ingredient_management/IngredientManagementApi';
import { queryKeys } from '../../../../../utils/queryKeys';
import {
  findMatchingApiIngredient,
  mapApiIngredientToMealIngredient,
} from '../../../../../utils/mealIngredientUtils';

const AddNewIngredientDialog = ({
  availableIngredients = [],
  onIngredientCreated,
  variant = 'contained',
}) => {
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);

  const createIngredientMutation = useMutation(createIngredient, {
    onSuccess: async (response, payload) => {
      await queryClient.invalidateQueries(queryKeys.getAllIngredientsData);

      const createdIngredient = mapApiIngredientToMealIngredient(
        response?.data ?? payload
      );
      onIngredientCreated?.(createdIngredient);
      toast.success('Ingredient created successfully');
      setOpen(false);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message ?? 'Unable to create ingredient');
    },
  });

  const handleSubmit = async (payload) => {
    const matchingIngredient = findMatchingApiIngredient(
      availableIngredients,
      payload
    );

    if (matchingIngredient) {
      onIngredientCreated?.(mapApiIngredientToMealIngredient(matchingIngredient));
      toast.success('Existing ingredient added to the meal');
      setOpen(false);
      return;
    }

    await createIngredientMutation.mutateAsync(payload);
  };

  return (
    <>
      <Button variant={variant} onClick={() => setOpen(true)}>
        Add new ingredient
      </Button>
      <IngredientManagementDialog
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={handleSubmit}
        ingredient={null}
        isSubmitting={createIngredientMutation.isLoading}
      />
    </>
  );
};

export default AddNewIngredientDialog;
